import { CurrencyPipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Apollo, QueryRef } from 'apollo-angular';
import { Subscription, take } from 'rxjs';
import { Invoice } from '../../shared/entities/payment/payment';
import { LoadingService } from '../../shared/services/loading.service';
import { PaymentsService } from '../../shared/services/payment/payment.service';
import { UsersService } from '../../shared/services/users/users.service';
import * as fromGraphQl from './graphql';

@Component({
  selector: 'app-billing-invoice-list',
  templateUrl: './billing-invoice-list.component.html',
  styleUrls: ['./billing-invoice-list.component.scss']
})
export class BillingInvoiceListComponent implements OnInit, OnDestroy {

  public invoices: Invoice[];
  public invoiceQuery: QueryRef<fromGraphQl.InvoicesQueryResponse>;
  public invoiceQuerySubscription: Subscription;
  public isLoading = true;
  
  constructor(
    public paymentService: PaymentsService,
    public currencyPipe: CurrencyPipe,
    private apollo: Apollo,
    public loadingService: LoadingService,
    private userSerivce: UsersService
  ) {
  }

  ngOnInit(): void {
    this.subscribeToInvoicesData();
  }

  ngOnDestroy(): void {
  }

  downloadInvoice(url: string) {
    window.open(url, '_blank');
  }

  subscribeToInvoicesData() {
    this.apollo.query<fromGraphQl.InvoicesQueryResponse>({
      fetchPolicy: 'network-only',
      query: fromGraphQl.INVOICES_QUERY,
      variables: {
        tenantId: this.userSerivce.getCurrentTenantId(),
      },
    }).pipe(
      take(1)
    ).subscribe( (data) => {
      this.isLoading = false;
      this.loadingService.setLoading(false);
      this.invoices = data?.data?.invoices;
    });
  }

  
}
